/**
 * Auth Module
 */
import Notificacion from '@/api/notificacion'

const state = {
  notificaciones: []
}

// getters
const getters = {
  notificaciones: state => state.notificaciones
}

// actions
const actions = {
  obtenerNotificaciones (context, payload) {
    // const datos = payload
    const { id } = payload

    return new Promise((resolve, reject) => {
      Notificacion.obtenerNotificaciones(id).then(
        data => {
          context.commit('setearNotificaciones', data)
          resolve(data)
        },
        error => {
          // context.commit('loginUserFailure', error)
          reject(error)
          // }, 500)
        }
      )
    })
  },
  obtenerNotificacionesNuevas (context, payload) {
    // const datos = payload
    const { id } = payload

    return new Promise((resolve, reject) => {
      Notificacion.obtenerNotificacionesNuevas(id).then(
        data => {
          context.commit('setearNotificaciones', data)
          resolve(data)
        },
        error => {
          // context.commit('loginUserFailure', error)
          reject(error)
          // }, 500)
        }
      )
    })
  }
}

// mutations
const mutations = {
  setearNotificaciones (state, notificaciones) {
    state.notificaciones = notificaciones
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
